module.exports = __webpack_public_path__ + "img/icon-checklist.83617872.svg";